module.exports = __webpack_public_path__ + "img/community08.1ded8bcb.png";